import { REPORT_GAIN_TYPE_COLUMN_LABEL } from "../../../utils/reports/reportDisplayLabels";

import { STOCK_TAX_REPORT_COLUMNS } from "../../../utils/equity/stockTaxReport";



export type FieldColumn = {

  key: string;

  value: string;

  locked?: boolean;

  minWidth?: number;

  align?: "left" | "center" | "right";

};



export const MF_POINT_TO_POINT_REPORT = "Point to Point Return";



export const MF_REPORT_TYPE_OPTIONS = [

  { value: "Holding", label: "Unrealized" },

  { value: "Realized", label: "Realized" },

  { value: "All", label: "All" },

  { value: "Transaction", label: "Transaction" },

  { value: "Transaction report", label: "Transaction Details" },

  { value: "Sector report", label: "Sector Report" },

  { value: "Cap report", label: "Market Cap Report" },

  { value: "Weekly Returns", label: "Weekly Returns" },

  { value: MF_POINT_TO_POINT_REPORT, label: "Point to Point Return" },

  { value: "Short Term Capital Gain", label: "Short Term Capital Gain" },

  { value: "Long Term Capital Gain", label: "Long Term Capital Gain" },

] as const;



export const MF_QUICK_REPORTS = [

  { id: "holding", label: "Unrealized", reportType: "Holding" },

  { id: "realized", label: "Realized", reportType: "Realized" },

  { id: "transaction-report", label: "Transaction Details", reportType: "Transaction report" },

  { id: "transaction", label: "Transaction", reportType: "Transaction" },

  { id: "p2p", label: "Point to Point Return", reportType: MF_POINT_TO_POINT_REPORT },

];



export const INVESTOR_COLUMN: FieldColumn = {

  key: "investorDisplay",

  value: "Investor Name",

  locked: true,

  minWidth: 200,

};



/** MF Unrealized (Holding) — aumsampaan `MF_UNREALIZED_HOLDING_COLUMNS`. */

export const MF_UNREALIZED_HOLDING_COLUMNS: FieldColumn[] = [

  { key: "schemeName", value: "Scheme Name", locked: true, minWidth: 200 },

  { key: "isin", value: "ISIN", minWidth: 96 },

  { key: "purchaseDate", value: "Purchase Date", minWidth: 112 },

  { key: "currentDate", value: "Current Date", minWidth: 112 },

  { key: "units", value: "Units", minWidth: 100 },

  { key: "purchasePrice", value: "Purchase Price", minWidth: 112 },

  { key: "currentNAV", value: "Current NAV", minWidth: 112 },

  { key: "costValue", value: "Invested", minWidth: 128 },

  { key: "currentValue", value: "Current Value", minWidth: 128 },

  { key: "unrealisedPNL", value: "P&L", minWidth: 132 },

  { key: "unrealisedPNLPercentage", value: "P&L %", minWidth: 96 },

];



/** aumsampaan `REALIZED_REPORT_COLUMNS_BASE`. */

export const MF_REALIZED_COLUMNS: FieldColumn[] = [

  { key: "schemeName", value: "Scheme Name", locked: true, minWidth: 200 },

  { key: "isin", value: "ISIN", minWidth: 96 },

  { key: "type", value: REPORT_GAIN_TYPE_COLUMN_LABEL, locked: true, minWidth: 132 },

  { key: "transactionDate", value: "Date", minWidth: 112 },

  { key: "units", value: "Units Sold", minWidth: 100 },

  { key: "purchaseNAV", value: "Sell Price", minWidth: 112 },

  { key: "avgBuyPrice", value: "Avg Buy Price", minWidth: 112 },

  { key: "saleValue", value: "Sale Value", minWidth: 128 },

  { key: "realisedPnl", value: "Realized P&L", minWidth: 132 },

  { key: "realisedPNLPercentage", value: "Realized P&L%", minWidth: 120 },

];



/** aumsampaan MF `HOLDING_TXN_REPORT_FIELD_TITLES_BASE` Transaction preset. */

export const MF_TRANSACTION_COLUMNS: FieldColumn[] = [

  { key: "transType", value: "Type", locked: true, minWidth: 120 },

  { key: "transactionDate", value: "Date", minWidth: 112 },

  { key: "currentDate", value: "Current Date", minWidth: 112 },

  { key: "folioNumber", value: "Folio Number", minWidth: 96 },

  { key: "units", value: "Units", minWidth: 100 },

  { key: "purchaseNAV", value: "Price", minWidth: 112 },

  { key: "currentNAV", value: "Current NAV", minWidth: 112 },

  { key: "costValue", value: "Amount", minWidth: 128 },

  { key: "currentValue", value: "Current Value", minWidth: 128 },

  { key: "realisedPnl", value: "Realised P&L", minWidth: 132 },

  { key: "realisedPNLPercentage", value: "Realised P&L %", minWidth: 120 },

  { key: "unrealisedPNL", value: "Unrealised P&L", minWidth: 132 },

  { key: "unrealisedPNLPercentage", value: "Unrealised P&L %", minWidth: 120 },

  { key: "days", value: "Avg. Days", minWidth: 88 },

];



/** aumsampaan `MFTransationsRaw`. */

export const MF_TRANSACTION_DETAILS_COLUMNS: FieldColumn[] = [

  { key: "transactiondate", value: "Transaction Date", locked: true, minWidth: 112 },

  { key: "schemeName", value: "Scheme Name", locked: true, minWidth: 220 },

  { key: "category", value: "Category", minWidth: 96 },

  { key: "transactionType", value: "Transaction Type", minWidth: 120 },

  { key: "folioNo", value: "Folio No.", minWidth: 96 },

  { key: "units", value: "Units", minWidth: 100 },

  { key: "amount", value: "Invested Amount", minWidth: 128 },

  { key: "currentValue", value: "Current Value", minWidth: 128 },

  { key: "currentDate", value: "Current Date", minWidth: 112 },

  { key: "cagr", value: "CAGR", minWidth: 96 },

  { key: "days", value: "Avg. Days", minWidth: 88 },

];



/** aumsampaan `MF_P2P_REPORT_COLUMNS` (without memberName). */

export const MF_P2P_COLUMNS: FieldColumn[] = [

  { key: "schemeName", value: "Scheme Name", locked: true, minWidth: 168 },

  { key: "type", value: REPORT_GAIN_TYPE_COLUMN_LABEL, locked: true, minWidth: 132 },

  { key: "purchaseDate", value: "Purchase Date", minWidth: 112 },

  { key: "currentDate", value: "Current Date", minWidth: 112 },

  { key: "days", value: "Avg. Days", minWidth: 88 },

  { key: "units", value: "Units", minWidth: 112 },

  { key: "currentNAV", value: "NAV", minWidth: 128 },

  { key: "investedAmount", value: "Invested", minWidth: 140 },

  { key: "currentAmount", value: "Current Value", minWidth: 148 },

  { key: "avgPrice", value: "Avg Price", minWidth: 112 },

  { key: "xirr", value: "XIRR", minWidth: 96 },

  { key: "cagr", value: "CAGR", minWidth: 96 },

  { key: "unrealisedPNL", value: "Unrealised P&L", minWidth: 132 },

  { key: "unrealisedPNLPercentage", value: "Unrealised P&L%", minWidth: 120 },

  { key: "realisedPnl", value: "Realised P&L", minWidth: 132 },

  { key: "realisedPNLPercentage", value: "Realised P&L%", minWidth: 120 },

  { key: "folioNo", value: "Folio No", minWidth: 128 },

];



/** aumsampaan `MFSectors` (without memberName). */

export const MF_SECTOR_COLUMNS: FieldColumn[] = [

  { key: "sector", value: "Sector Name", locked: true, align: "center" },

  { key: "amount", value: "Invested Amount (₹)", locked: true, align: "center" },

];



/** aumsampaan `MFCaps` (without memberName). */

export const MF_CAP_COLUMNS: FieldColumn[] = [

  { key: "category", value: "Category", locked: true, align: "center" },

  { key: "value", value: "Invested Amount (₹)", locked: true, align: "center" },

];



/** aumsampaan `MFWeeklyReturns`. */

export const MF_WEEKLY_RETURNS_COLUMNS: FieldColumn[] = [

  { key: "schemeName", value: "Scheme Name", locked: true, minWidth: 200 },

  { key: "units", value: "Units", minWidth: 100 },

  { key: "amount", value: "Investment Amount (₹)", minWidth: 160 },

  { key: "currentVal", value: "Current Value (₹)", minWidth: 160 },

  { key: "weeklyReturn", value: "Weekly Return (₹)", minWidth: 140 },

  { key: "weeklyReturnPercentage", value: "Weekly Return (%)", minWidth: 140 },

];



/** aumsampaan `STOCK_TAX_REPORT_COLUMNS`. */

export const MF_TAX_COLUMNS: FieldColumn[] = STOCK_TAX_REPORT_COLUMNS.map((c) => ({

  key: c.key,

  value: c.value,

  locked: c.locked,

}));



/** aumsampaan `ALL_COMMON_COLUMNS_BASE` + MF nav cols for All report. */

export const MF_ALL_COMMON_COLUMNS: FieldColumn[] = [

  { key: "schemeName", value: "Scheme Name", locked: true, minWidth: 200 },

  { key: "isin", value: "ISIN", minWidth: 96 },

  { key: "type", value: REPORT_GAIN_TYPE_COLUMN_LABEL, locked: true, minWidth: 132 },

  { key: "folioNumber", value: "Folio Number", minWidth: 96 },

  { key: "units", value: "Units", minWidth: 100 },

  { key: "averageNav", value: "Average NAV", minWidth: 112 },

  { key: "currentNAV", value: "Current NAV", minWidth: 112 },

  { key: "costValue", value: "Invested Amount", minWidth: 128 },

  { key: "currentValue", value: "Current Value", minWidth: 128 },

  { key: "gainLoss", value: "P&L", minWidth: 132 },

  { key: "gainLossPercentage", value: "P&L %", minWidth: 96 },

];



export const getColumnsForReportType = (reportType: string): FieldColumn[] => {

  switch (reportType) {

    case "Holding":

      return MF_UNREALIZED_HOLDING_COLUMNS;

    case "Realized":

      return MF_REALIZED_COLUMNS;

    case "All":

      return MF_ALL_COMMON_COLUMNS;

    case "Transaction":

      return MF_TRANSACTION_COLUMNS;

    case "Transaction report":

      return MF_TRANSACTION_DETAILS_COLUMNS;

    case "Sector report":

      return MF_SECTOR_COLUMNS;

    case "Cap report":

      return MF_CAP_COLUMNS;

    case "Weekly Returns":

      return MF_WEEKLY_RETURNS_COLUMNS;

    case MF_POINT_TO_POINT_REPORT:

      return MF_P2P_COLUMNS;

    case "Short Term Capital Gain":

    case "Long Term Capital Gain":

      return MF_TAX_COLUMNS;

    default:

      return MF_UNREALIZED_HOLDING_COLUMNS;

  }

};



export const reportTypeNeedsDateRange = (reportType: string): boolean =>

  [

    "Holding",

    "Transaction report",

    MF_POINT_TO_POINT_REPORT,

    "Short Term Capital Gain",

    "Long Term Capital Gain",

  ].includes(reportType);



export const INDIVIDUAL_USER_TYPE = 1;

export const NON_INDIVIDUAL_USER_TYPE = 5;


